'use strict';

(function (window, videojs) {

var VjsButton = videojs.getComponent('Button');


function enlarge(options) {
    var player = this;

    player.ready(function() {
            let button = player.controlBar.addChild(
                new VjsButton(player, {
                    el: videojs.createEl(
                        'button',
                        {
                            className: 'vjs-res-button vjs-control',
                            innerHTML: '<div class="vjs-control-content" style="font-size: 11px; line-height: 28px;"><span class="vjs-fbf"><i class="fa fa-expand"></i></span></div>'
                        },
                        {
                            role: 'button'
                        }
                    ),

                }),
            );

            insertBeforeNode = document.getElementsByClassName('vjs-fullscreen-control')[0];
            controlBar.insertBefore(button.el(), insertBeforeNode);

    });
}
videojs.plugin('enlarge', enlarge);

})(window, videojs);



// WEBPACK FOOTER //
// ./src/packages/videojs-enlarge/index.js